export class Range {
  constructor(
    public min = 0,
    public max = 0
  ) {}
}
